import script from "./TecnicoTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TecnicoTable.vue?vue&type=script&setup=true&lang=js"

import "./TecnicoTable.vue?vue&type=style&index=0&id=75c714d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75c714d4"]])

export default __exports__